
/**
 * @export
 * @enum {string}
 */
export enum TemplateType {
    DEFAULT = 'DEFAULT',
    CUSTOM = 'CUSTOM'
}